export default __webpack_public_path__ + "static/media/D-900-TOUCH.5678fed3.pdf";